import gsap from 'gsap'
import Lenis from 'lenis'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export let lenis, scrollToStart

export const initLenis = () => {

  lenis = new Lenis({
		duration: 0.9,
		anchors: {
			offset: -118,
			duration: 1.8
		}
  })

	lenis.on('scroll', ScrollTrigger.update())

	gsap.ticker.add((time) => {
		lenis.raf(time * 1000)
	})

	gsap.ticker.lagSmoothing(0)

	function raf(time) {
		lenis.raf(time)
		requestAnimationFrame(raf)

		if (lenis.scroll > 200) {
      document.documentElement.dataset.scrolled = true
    } else {
      document.documentElement.dataset.scrolled = false
    }

		if (lenis.direction == 1 && lenis.scroll > 0) {
      document.documentElement.dataset.direction = 'forward'
    } else {
      document.documentElement.dataset.direction = 'backward'
    }
	}

	scrollTo()
	requestAnimationFrame(raf)

}

export const scrollTo = () => {
	const links = document.querySelectorAll('[data-scroll-to]')

	if (!links) return

	links.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault()
			const target = link.getAttribute('data-scroll-to')
			const offset = link.getAttribute('data-scroll-offset')
			const targetEl = document.querySelector(target)
			lenis.scrollTo(targetEl, {
				duration: 1.5,
				offset: offset ? Number(offset) : 0,
				easing: (x) => {
					return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2
				}
			})
		})
	})
}

export const parallax = () => {

  const els = document.querySelectorAll('[data-speed]')
  const topEls = document.querySelectorAll('[data-speed-full]')

  if (els.length && window.innerWidth > 1025) {
    els.forEach(pr => {

      let debounce
      let parallax = gsap.to(pr, {
        y: (i, el) => (1 - parseFloat(el.getAttribute("data-speed"))) * window.innerHeight,
        ease: 'none',
        scrollTrigger: {
          trigger: pr,
          start: 'top bottom',
          end: 'bottom top',
          invalidateOnRefresh: true,
          scrub: 1,
        }
      })

      window.addEventListener('resize', () => {
        clearTimeout(debounce)
        debounce = setTimeout(() => {
          if (window.innerWidth < 1024) {
            parallax.kill()
            gsap.set(pr, { clearProps: 'all' })
            parallax = null
          }
        }, 300)
      })

    })
  }

  let debounce
  let browserWidth = window.innerWidth

  if (topEls.length) {
    let bannerParallax = gsap.to(topEls, {
      y: (i, el) => (1 - parseFloat(el.getAttribute('data-speed-full'))) * ScrollTrigger.maxScroll(window) ,
      ease: 'none',
      scrollTrigger: {
        start: 0,
        end: 'max',
        invalidateOnRefresh: true,
        scrub: true
      }
    })
  }
  
  window.addEventListener('resize', () => {
    clearTimeout(debounce)
    debounce = setTimeout(() => {
      if (window.innerWidth != browserWidth && window.innerWidth < 1024) {
        browserWidth = window.innerWidth
        gsap.set(topEls, { clearProps: 'all' })
        if (!bannerParallax) return
        bannerParallax.kill()
        bannerParallax = null
      }
    }, 300)
  })
}

scrollToStart = () => {
  lenis.scrollTo(0, { immediate: true })
}

export default () => {}
